module.exports = __webpack_public_path__ + "img/image-hero-blackcup.a0ee0160.jpg";